"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const core_2 = require("@ngx-translate/core");
const rxjs_1 = require("rxjs");
class NormaliseAclPipe {
    constructor(t) {
        this.t = t;
    }
    transform(value, ...args) {
        if (value) {
            return this.t.get('GENERIC.ACL.' + value.toUpperCase());
            //let string = value.replace(/_/g, ' ');
            //return string.charAt(0).toUpperCase() + string.slice(1);
        }
        else {
            return rxjs_1.of(value);
        }
    }
}
exports.NormaliseAclPipe = NormaliseAclPipe;
